import React from 'react';
import RevenuesComponent  from '../components/Revenues';
import { Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const Revenues = () => {
  
  return (
    <div className="content-wrapper">
      <h3>Receitas</h3>
        <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item>
            <Link to="/">Início</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Receitas</Breadcrumb.Item>
        </Breadcrumb>
      <Row>
        <Col
          xs={0} // Esconde em dispositivos pequenos
          sm={0} // Esconde em dispositivos médios
          md={24} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <RevenuesComponent />
        </Col>
        <Col
          xs={24} // Esconde em dispositivos pequenos
          sm={24} // Esconde em dispositivos médios
          md={0} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <RevenuesComponent />
        </Col>
      </Row>
    </div>
  );
};

export default Revenues;